/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Footer_TaglineInputs */

const en_fc_footer_tagline = /** @type {(inputs: Fc_Footer_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your FilmCraft download and editing guide.`)
};

/**
* | output |
* | --- |
* | "Your FilmCraft download and editing guide." |
*
* @param {Fc_Footer_TaglineInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_footer_tagline = /** @type {((inputs?: Fc_Footer_TaglineInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Footer_TaglineInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_footer_tagline(inputs)
});
export { fc_footer_tagline as "fc.footer.tagline" }